/**
 * design-tools/VignetteOverlay.jsx
 * Adds a cinematic edge vignette to a section
 */
export default function VignetteOverlay({ strength = 0.7, color = '#0a1210' }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 1,
        background: `radial-gradient(ellipse at center, transparent 40%, ${color}${Math.round(strength * 255).toString(16).padStart(2,'0')} 100%)`,
      }}
    />
  );
}
